import { loadPricing, wpLoadService } from './loaders';
import { history } from '../globals/config';
import contactGarage from '../modules/contactGarage';
import { generateSummary } from '../modules/summary';
import qtAnalytics, { handleImpressions } from './qtAnalytics';

const $ = jQuery;
const $returnBtn = $('.js-qt-return');
const $quoteTool = $('#quote-tool'); // Cache the .quote-tool element for reuse

/**
 * Changing active steps.
 */
export default function (stepName, clickedElement) {
	$returnBtn.show();
	updateQuoteToolClass(stepName); // Update class on step change

	if (stepName === 'diagnosis') {
		wpLoadService();
	} else if (stepName === 'calculation') {
		loadPricing();
	} else if (stepName === 'schedule') {
		qtAnalytics('date-picker-start');
	} else if (stepName === 'summary') {
		generateSummary();
		qtAnalytics('validation-start');
	} else {
		if (stepName === 'contact') {
			contactGarage();
		}
		$('#quote-tool section.active').removeClass('active');
		$(`#quote-tool section[data-step-name="${stepName}"]`).addClass('active');

		if (document.querySelector('.garage-locator').classList.contains('active')) {
			let item1Height = $('.garage-locator__item:nth-child(1)').outerHeight();
			let item2Height = $('.garage-locator__item:nth-child(2)').outerHeight();
			let item3Height = $('.garage-locator__item:nth-child(3)').outerHeight();
			$('.garage-locator__locations').show();

			// If not all 3, then do nothing
			if (!item1Height || !item2Height || !item3Height) {
				return;
			}
			let listHeight = Number(item1Height) + Number(item2Height) + Number(item3Height) / 2 + 28 + 'px';
			$('.garage-locator__locations-wrap').css('height', listHeight);
		}

		/**
		 * Tracking of step load
		 */
		let toolStep = $(clickedElement).attr('data-tool-step');
		let toolStepOption = $(clickedElement).attr('data-tool-step-option');

		handleSteps(stepName, toolStep, toolStepOption);
	}

	$('#quote-tool section.active').removeClass('active');
	$(`#quote-tool section[data-step-name="${stepName}"]`).addClass('active');

	$([document.documentElement, document.body]).animate(
		{
			scrollTop: $('#quote-tool').offset().top,
		},
		0
	);
	navigation();
}

/**
 * Updates .quote-tool to only have the current step class.
 */
function updateQuoteToolClass(stepName) {
	const sanitizedStepName = `step-${stepName.replace(/\s+/g, '-')}`; // Replace spaces with hyphens
	$quoteTool
		.removeClass((index, className) => (className.match(/(^|\s)step-\S+/g) || []).join(' ')) // Remove all step-related classes
		.addClass(sanitizedStepName); // Add current step class
}

function navigation() {
	const stepName = $('.c-qt-content > section.active').data('step-name');
	const $progressLine = $('.js-qt-progress-line');
	const steps = [$('.js-qt-navigation-first-step'), $('.js-qt-navigation-second-step'), $('.js-qt-navigation-third-step'), $('.js-qt-navigation-fourth-step')];

	if (stepName) {
		// Reset all classes
		$progressLine.removeClass('first second third fourth');
		steps.forEach((step) => step.removeClass('active current'));

		switch (stepName) {
			case 'start':
			case 'reports':
			case 'step - 1':
			case 'step - 1 - 0':
			case 'step - 1 - 0 - 0':
			case 'step - 1 - 0 - 1':
			case 'step - 1 - 2 - 1':
			case 'step - 1 - 2':
			case 'step - 1 - 5':
			case 'step - 1 - 6':
			case 'additional-info':
				// First step
				$progressLine.addClass('first');
				steps[0].addClass('active current');
				break;

			case 'diagnosis':
				// Second step
				$progressLine.addClass('second');
				steps[0].addClass('active');
				steps[1].addClass('active current');
				break;

			case 'vehicle':
			case 'garage-locator':
				// Third step
				$progressLine.addClass('third');
				steps[0].addClass('active');
				steps[1].addClass('active');
				steps[2].addClass('active current');
				break;

			default:
				// Fourth step
				$progressLine.addClass('fourth');
				steps[0].addClass('active');
				steps[1].addClass('active');
				steps[2].addClass('active');
				steps[3].addClass('active current');
				break;
		}
	}
}

function handleSteps(stepName, toolStep, toolStepOption) {
	const stepAnalyticsMapping = {
		reports: () => qtAnalytics('issue-start'),
		vehicle: () => qtAnalytics('vehicle-info-start'),
		'garage-locator': () => {
			if (history[history.length - 1] === 'reports') {
				qtAnalytics('issue-submit', 'urgency');
				qtAnalytics('dealer-start');
				handleImpressions('urgency-dealer');
			}

			if (toolStep === 'starting-vehicle') {
				qtAnalytics('starting-vehicle-submit', toolStepOption === 'vehicle-start-yes' ? 'yes' : 'no');
				handleImpressions('dealer-impression');
				qtAnalytics('dealer-start');
			}

			if (toolStep === 'noises-abnormal') {
				qtAnalytics('noises-abnormal-submit', toolStepOption);
				handleImpressions('dealer-impression');
				qtAnalytics('dealer-start');
			}
		},
		contact: () => {
			if (history[[history.length - 3]] === 'reports') {
				handleImpressions('urgency-contact');
			}
		},
		uncertainty: () => qtAnalytics('uncertainty-start'),
		'step - 1': () => {
			qtAnalytics('issue-submit', 'uncertainty');
			qtAnalytics('uncertainty-start');
		},
		'step - 1 - 0': () => {
			if (toolStep || toolStepOption) {
				qtAnalytics('uncertainty-submit', toolStepOption);
			}
			qtAnalytics('dashboard-start');
		},
		'step - 1 - 0 - 0': () => handleDashboardSubmit(),
		'step - 1 - 0 - 1': () => handleDashboardSubmit(),
		'step - 1 - 2': () => handleUncertaintySubmit('starting-vehicle-start'),
		'step - 1 - 5': () => handleUncertaintySubmit('control-loss-start'),
		'step - 1 - 6': () => handleUncertaintySubmit('noises-abnormal-start'),
		user_info: () => qtAnalytics('personal-info-start'),
		'thank-you': () => {
			$returnBtn.hide();
			qtAnalytics('validation-submit');
			qtAnalytics('thank-you-start');
		},
		start: () => $returnBtn.hide(),
		'additional-info': () => {
			if (toolStep || toolStepOption) {
				if (toolStep === 'uncertainty') {
					qtAnalytics('uncertainty-submit', toolStepOption);

					if (toolStepOption === 'noises-brakes') {
						handleImpressions('noises');
					}

					if (toolStepOption === 'braking-efficiency') {
						handleImpressions('specific-request');
					}

					if (toolStepOption === 'power') {
						handleImpressions('technical-control');
					}
				}

				if (toolStep === 'starting-vehicle') {
					qtAnalytics('starting-vehicle-submit', toolStepOption === 'vehicle-start-yes' ? 'yes' : 'no');
				}

				if (toolStep === 'control-loss') {
					qtAnalytics('control-loss-submit', toolStepOption);
				}

				if (toolStep === 'noises-abnormal') {
					qtAnalytics('noises-abnormal-submit', toolStepOption);
				}
			}

			if (toolStepOption === 'noises-brakes' || toolStepOption === 'braking-efficiency' || toolStepOption === 'power' || toolStepOption === 'control') {
				qtAnalytics('extra-info-start', '', 2.2);
			} else {
				if (toolStep === undefined && toolStepOption === undefined) {
					qtAnalytics('extra-info-start', null, 2.4);
				} else {
					qtAnalytics('extra-info-start');
				}
			}
		},
	};

	function handleDashboardSubmit() {
		if (toolStep || toolStepOption) {
			qtAnalytics('dashboard-submit', toolStepOption);

			if (toolStepOption === 'red') {
				handleImpressions('red-symbol');
			}

			if (toolStepOption === 'orange') {
				handleImpressions('orange-symbol');
			}
		}
		qtAnalytics('symbol-start');
	}

	function handleUncertaintySubmit(nextStep) {
		if (toolStep || toolStepOption) {
			qtAnalytics('uncertainty-submit', toolStepOption);
		}

		if (nextStep === 'noises-abnormal-start') {
			handleImpressions('noises');
		}
		qtAnalytics(nextStep);
	}

	if (stepAnalyticsMapping[stepName]) {
		stepAnalyticsMapping[stepName]();
	}
}
